// extracted by css-extract-rspack-plugin
export default {"root":"root-NKavCr","title":"title-HcwKY5","lead":"lead-G3If6J","link":"link-x_xkP6","image":"image-i7XbvJ"};